import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import Section from 'Components/Common/Details/Section';
import { universitiesMetadataGetRequest, universityGetRequest, universityUpdateRequest } from 'store/university/action';
import Finance from './Finance';
import Contracts from './Contract/Contracts';

const Details = (props: any) => {
    const tabList = [{
        title: (props.t("common.tabs.finance")),
        component: Finance
    },
    {
        title: (props.t("common.tabs.contracts")),
        component: Contracts
    }
]
    
    return (
        <React.Fragment>
            <div className="page-content">                
                <Container fluid>       
                <Section 
                    detailsGetAction={universityGetRequest}
                    metaDatagetRequest={universitiesMetadataGetRequest}
                    updateAction={universityUpdateRequest}
                    model={"institutes"}
                    reducerState={"universities"}
                    translater={"institute"}
                    label={"Institute"}
                    tabList={tabList}

                />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withTranslation()(Details);